import { toastr } from 'react-redux-toastr';
import QueryString from 'query-string';
import { isErrorResponse } from '../../utils/error-handlers';
import {
  BAGGAGE_ITEM,
  generateMarkBaggageItemDepuratedEndpoint,
} from '../../config/endpoints';
import {
  DEFAULT_GET_CONFIG,
  DEFAULT_POST_CONFIG,
  DEFAULT_PUT_CONFIG,
} from '../../config/rest';
import {
  CLEAR_BAGGAGE_ITEMS,
  FLAG_GETTING_BAGGAGE_ITEMS,
  FLAG_ITEM_ACTIVITY,
  GET_BAGGAGE_ITEMS,
  GET_BAGGAGE_ITEM,
  CLEAR_BAGGAGE_ITEM,
} from '../types';

const flagGettingBaggageItem = (flag) => (dispatch) =>
  dispatch({
    type: FLAG_GETTING_BAGGAGE_ITEMS,
    payload: flag,
  });

const getItems = async (tableFilters) => async (dispatch) => {
  try {
    dispatch(flagGettingBaggageItem(true));
    const query = tableFilters;
    const url = `${BAGGAGE_ITEM}?${QueryString.stringify(query)}`;
    const response = await fetch(url, DEFAULT_GET_CONFIG);
    await isErrorResponse(response, null, dispatch);
    const data = await response.json();
    dispatch({
      type: GET_BAGGAGE_ITEMS,
      payload: data,
    });
  } catch (error) {
    toastr.error('Error', error.message);
  } finally {
    dispatch(flagGettingBaggageItem(false));
  }
};

const getItemsByItineraryId =
  ({ itineraryId }) =>
  async (dispatch) => {
    try {
      dispatch(flagGettingBaggageItem(true));
      const url = `${BAGGAGE_ITEM}/itinerary/${itineraryId}`;
      const response = await fetch(url, DEFAULT_GET_CONFIG);
      await isErrorResponse(response, null, dispatch);
      const data = await response.json();
      dispatch({
        type: GET_BAGGAGE_ITEMS,
        payload: data,
      });
      return data;
    } catch (error) {
      toastr.error('Error', error.message);
      return null;
    } finally {
      dispatch(flagGettingBaggageItem(false));
    }
  };

const clearBaggageItems = () => (dispatch) =>
  dispatch({
    type: CLEAR_BAGGAGE_ITEMS,
  });

const getBaggageItemByCorrelative = (correlative) => async (dispatch) => {
  try {
    dispatch(flagGettingBaggageItem(true));
    const url = `${BAGGAGE_ITEM}/correlation?correlative=${encodeURIComponent(
      correlative,
    )}`;
    const response = await fetch(url, DEFAULT_GET_CONFIG);
    await isErrorResponse(response, null, dispatch);
    const data = await response.json();
    return data;
  } catch (error) {
    toastr.error('Error', error.message);
    return null;
  } finally {
    dispatch(flagGettingBaggageItem(false));
  }
};

const flagItemActivity = (activity) => (dispatch) =>
  dispatch({
    type: FLAG_ITEM_ACTIVITY,
    payload: activity,
  });

const putUploadItemToItinerary =
  async ({ itineraryId, itemIds }) =>
  async (dispatch) => {
    try {
      dispatch(flagItemActivity(true));
      const url = `${BAGGAGE_ITEM}/actions/upload-itinerary/${itineraryId}`;
      const response = await fetch(url, {
        ...DEFAULT_PUT_CONFIG,
        body: JSON.stringify(itemIds),
      });
      await isErrorResponse(response, null, dispatch);
      toastr.success('Exito', 'Se agregaron los equipajes al nuevo itinerario');
      return response.json();
    } catch (error) {
      toastr.error('Error', error.message);
      return null;
    } finally {
      dispatch(flagItemActivity(false));
    }
  };

const putDismissItemItinerary =
  async ({ itemIds, comment, locationId }) =>
  async (dispatch) => {
    try {
      dispatch(flagItemActivity(true));
      const url = `${BAGGAGE_ITEM}/actions/dismiss-itinerary`;
      const payload = {
        itemIds,
        comment,
        locationId,
      };
      const response = await fetch(url, {
        ...DEFAULT_PUT_CONFIG,
        body: JSON.stringify(payload),
      });
      await isErrorResponse(response, null, dispatch);
      toastr.success('Exito', 'Se descartaron los equipajes del itinerario');
      return response.json();
    } catch (error) {
      toastr.error('Error', error.message);
      return null;
    } finally {
      dispatch(flagItemActivity(false));
    }
  };

const putChangeItemItinerary =
  async ({ itemIds, newItineraryId }) =>
  async (dispatch) => {
    try {
      dispatch(flagItemActivity(true));
      const url = `${BAGGAGE_ITEM}/actions/change-itinerary`;
      const payload = {
        itemIds,
        newItineraryId,
      };
      const response = await fetch(url, {
        ...DEFAULT_PUT_CONFIG,
        body: JSON.stringify(payload),
      });
      await isErrorResponse(response, null, dispatch);
      toastr.success('Exito', 'Se cambiaron los equipajes al nuevo itinerario');
      return response.json();
    } catch (error) {
      toastr.error('Error', error.message);
      return null;
    } finally {
      dispatch(flagItemActivity(false));
    }
  };

const putDeliverItems =
  async ({ itemIds, locationId, comment }) =>
  async (dispatch) => {
    try {
      dispatch(flagItemActivity(true));
      const url = `${BAGGAGE_ITEM}/actions/deliver`;
      const payload = {
        itemIds,
        locationId,
        comment,
      };
      const response = await fetch(url, {
        ...DEFAULT_PUT_CONFIG,
        body: JSON.stringify(payload),
      });
      await isErrorResponse(response, null, dispatch);
      const result = await response.json();
      const deliveredCount = result.filter((r) => r.success).length;
      if (deliveredCount > 0) {
        toastr.success(
          'Exito',
          `Se entregaron ${deliveredCount} de ${itemIds.length} equipajes`,
        );
      }
      return result;
    } catch (error) {
      toastr.error('Error', error.message);
      return null;
    } finally {
      dispatch(flagItemActivity(false));
    }
  };

const putForceDeliverItems =
  async ({ itemIds, locationId, comment }) =>
  async (dispatch) => {
    try {
      dispatch(flagItemActivity(true));
      const url = `${BAGGAGE_ITEM}/actions/force-deliver`;
      const payload = {
        itemIds,
        locationId,
        comment,
      };
      const response = await fetch(url, {
        ...DEFAULT_PUT_CONFIG,
        body: JSON.stringify(payload),
      });
      await isErrorResponse(response, null, dispatch);
      await response.json();
    } catch (error) {
      toastr.error('Error', error.message);
    } finally {
      dispatch(flagItemActivity(false));
    }
  };

const putMarkSeized =
  async ({ itemIds, locationId, comment }) =>
  async (dispatch) => {
    try {
      dispatch(flagItemActivity(true));
      const url = `${BAGGAGE_ITEM}/actions/mark-seized`;
      const payload = {
        itemIds,
        locationId,
        comment,
      };
      const response = await fetch(url, {
        ...DEFAULT_PUT_CONFIG,
        body: JSON.stringify(payload),
      });
      await isErrorResponse(response, null, dispatch);
      await response.json();
    } catch (error) {
      toastr.error('Error', error.message);
    } finally {
      dispatch(flagItemActivity(false));
    }
  };

const postReportIssue =
  async ({ itemIds, comment, locationId, itineraryId, itemIncidentType }) =>
  async (dispatch) => {
    try {
      dispatch(flagItemActivity(true));
      const url = `${BAGGAGE_ITEM}/actions/report-incident`;
      const payload = {
        itemIds,
        comment,
        locationId,
        itineraryId,
        itemIncidentType,
      };
      const response = await fetch(url, {
        ...DEFAULT_POST_CONFIG,
        body: JSON.stringify(payload),
      });
      await isErrorResponse(response, null, dispatch);
      toastr.success('Exito', 'Se reportó el incidente del equipaje');
      return response.json();
    } catch (error) {
      toastr.error('Error', error.message);
      return null;
    } finally {
      dispatch(flagItemActivity(false));
    }
  };

const postMarkNotArrived =
  async ({ itemIds, comment, locationId, itineraryId }) =>
  async (dispatch) => {
    try {
      dispatch(flagItemActivity(true));
      const url = `${BAGGAGE_ITEM}/actions/mark-not-arrived`;
      const payload = {
        itemIds,
        comment,
        locationId,
        itineraryId,
      };
      const response = await fetch(url, {
        ...DEFAULT_PUT_CONFIG,
        body: JSON.stringify(payload),
      });
      await isErrorResponse(response, null, dispatch);
      toastr.success('Exito', 'Se marcó el equipaje como no arribado');
    } catch (error) {
      toastr.error('Error', error.message);
    } finally {
      dispatch(flagItemActivity(false));
    }
  };

const clearBaggageItem = () => (dispatch) =>
  dispatch({
    type: CLEAR_BAGGAGE_ITEM,
  });

const getBaggageItemById = (id) => async (dispatch) => {
  try {
    dispatch(flagItemActivity(true));
    const url = `${BAGGAGE_ITEM}/${id}`;
    const response = await fetch(url, DEFAULT_GET_CONFIG);
    await isErrorResponse(response, null, dispatch);
    const data = await response.json();
    dispatch({
      type: GET_BAGGAGE_ITEM,
      payload: data,
    });
    return data;
  } catch (error) {
    toastr.error('Error', error.message);
    return null;
  } finally {
    dispatch(flagItemActivity(false));
  }
};

const postAddItemComment =
  async ({ id, comment }) =>
  async (dispatch) => {
    try {
      dispatch(flagItemActivity(true));
      const url = `${BAGGAGE_ITEM}/${id}/comment`;
      const payload = {
        comment,
      };
      const response = await fetch(url, {
        ...DEFAULT_POST_CONFIG,
        body: JSON.stringify(payload),
      });
      await isErrorResponse(response, null, dispatch);
      toastr.success('Exito', 'Se agregó el comentario al equipaje');
    } catch (error) {
      toastr.error('Error', error.message);
    } finally {
      dispatch(flagItemActivity(false));
    }
  };

const putMarkDepuratedById =
  async ({ id }) =>
  async (dispatch) => {
    try {
      dispatch(flagItemActivity(true));
      const url = generateMarkBaggageItemDepuratedEndpoint(id);
      const response = await fetch(url, {
        ...DEFAULT_PUT_CONFIG,
      });
      await isErrorResponse(response, null, dispatch);
      toastr.success('Exito', 'Se marcó el equipaje como depurado');
    } catch (error) {
      toastr.error('Error', error.message);
    } finally {
      dispatch(flagItemActivity(false));
    }
  };

export {
  flagGettingBaggageItem,
  getItemsByItineraryId,
  clearBaggageItems,
  getBaggageItemByCorrelative,
  putUploadItemToItinerary,
  putDismissItemItinerary,
  putChangeItemItinerary,
  putDeliverItems,
  getItems,
  getBaggageItemById,
  clearBaggageItem,
  postReportIssue,
  postAddItemComment,
  postMarkNotArrived,
  putMarkDepuratedById,
  putForceDeliverItems,
  putMarkSeized,
};
